import { render } from "./ResidentRegister.vue?vue&type=template&id=768a10c5&scoped=true&ts=true"
import script from "./ResidentRegister.vue?vue&type=script&lang=ts"
export * from "./ResidentRegister.vue?vue&type=script&lang=ts"

import "./ResidentRegister.vue?vue&type=style&index=0&id=768a10c5&scoped=true&lang=css"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768a10c5"]])

export default __exports__